
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";
import { ErrorResponse } from "@/common/types/errorResponse";

interface UseDeleteGovernmentAllocationDistributionLimitProps {
  governmentAllocationId?: string;
  productCategoryDistributionLimitId: string;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useDeleteGovernmentAllocationDistributionLimit = ({
  governmentAllocationId,
  productCategoryDistributionLimitId,
  onSuccess,
  onError,
}: UseDeleteGovernmentAllocationDistributionLimitProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['deleteGovernmentAllocationDistributionLimit', governmentAllocationId, productCategoryDistributionLimitId],
    mutationFn: () => {
      const payload = {
        id: productCategoryDistributionLimitId,
        _destroy: true,
      };

      return privateAxios.put(`/billing/government_allocations/${governmentAllocationId}/update_distribution_limits`, {
        product_category_distribution_limits_attributes: [payload],
      });
    },
    onSuccess,
    onError,
  });
}
